import { Log } from '@scayle/storefront-nuxt'
import { defineNuxtPlugin } from '#app/nuxt'

export default defineNuxtPlugin({
  // Nuxt 4 plugin ordering: must run AFTER Scayle's log.client plugin
  // which is the one that provides nuxtApp.$log on the client.
  enforce: 'post',
  setup(nuxtApp) {
    const logger = useLog(undefined)
    ;(Log as unknown as { default: typeof logger }).default = logger

    nuxtApp.hook('vue:error', (error: any) => {
      if (error?.statusCode === 404 || error?.statusCode === 422) return
      useLog('vue:error').error(error)
    })

    nuxtApp.vueApp.config.errorHandler = (error: any, vm, info) => {
      logger.error(error, { vm, info })
    }

    nuxtApp.vueApp.config.warnHandler = (msg, vm, trace) => {
      logger.warn(msg, { vm, trace })
    }
  },
})
